// Import packages
import React, {Component} from "react";
import {connect} from "react-redux";

// Import components
import PageWrapper from "../../components/pageContentViews/pageWrapper";
import PageHeader from "../../components/pageContentViews/pageHeader";

// Import utils
import {mapStateToProps} from "../../redux/mapStateToProps";
import {deleteItem} from "../../utils/helperFunctions";
import {
    GetBrandTypes,
    DeleteBrandTypesById,
    UpdateBrandTypesPositions
} from "../../redux/actions";
import Nestable from "react-nestable";
import {NestableItem} from "../../components/cards/nestableItem";


class BrandTypes extends Component {
    constructor(props) {
        super(props);
        this.onPositionChange = this.onPositionChange.bind(this);
    }

    componentDidMount() {
        this.props.GetBrandTypes();
    }

    getNestableItems(list) {
        const {mainLanguage} = this.props;
        const items = [];
        list && !!list.length && list.forEach((item, index) => {
            const {id, isHidden, title} = item;
            items.push({
                id: id,
                index: index,
                title: title,
                isHidden: isHidden,
                withImage: false,
                largeItem: false,
                link: `brandTypes/edit/${item.id}`,
                deleteCb: deleteItem.bind(this, this.props.DeleteBrandTypesById, 'բրենդի տեսակը', id),
            })
        });
        return items;
    }

    async onPositionChange(items, item) {
        const movedFilterId = item.id;
        const {brandTypesList} = this.props;
        const positionedItems = items.map((item, index) => {
            return {id: item.id, position: index}
        });
        if (~brandTypesList.findIndex(m => m.id === movedFilterId) &&
            ~positionedItems.findIndex(m => m.id === movedFilterId)) {
            // first level menu was re-positioned in first level
            await this.props.UpdateBrandTypesPositions(positionedItems);
            this.props.GetBrandTypes();
        }
    }

    render() {
        let {brandTypesList} = this.props;
        let items = this.getNestableItems(brandTypesList);
        return <PageWrapper pageTitle={'Բրենդի տեսակներ'}>
            <PageHeader linkTitle={"Ավելացնել"}
                        addingLink={"/brandTypes/add"}/>
            {items && items.length !== 0 &&
            <Nestable
                items={items}
                maxDepth={1}
                onChange={this.onPositionChange}
                renderItem={NestableItem}
            />}
        </PageWrapper>
    }
}

const mapDispatchToProps = {
    GetBrandTypes,
    DeleteBrandTypesById,
    UpdateBrandTypesPositions,
};

export default connect(mapStateToProps, mapDispatchToProps)(BrandTypes);
